<template>
    <Container class="container-sm-none">
        <Card class="card-shadow mt-15 mt-md-0">
          <div class="width-lg">
            <div class="pl-10 pl-md-0 pr-10 pr-md-0">
              <EidSuccess v-if="model.delivery.deliveryType === DeliveryTypeEnum.EID" :model="model" />
              <CourierSuccess v-if="model.delivery.deliveryType === DeliveryTypeEnum.COURIER" :model="model" />
              <PostSuccess v-if="model.delivery.deliveryType === DeliveryTypeEnum.POST" :model="model" />
              <PrintSuccess v-if="model.delivery.deliveryType === DeliveryTypeEnum.PRINT" :model="model" />
              <ContactPlaceSuccess v-if="model.delivery.deliveryType === DeliveryTypeEnum.CONTACT_PLACE" :model="model" />
            </div>
          </div>
        </Card>
    </Container>
</template>

<script>
import Card from '@/components/Card/Card.vue';
import Container from '@/components/Container/Container.vue';
import EidSuccess from '@/pagesComponents/ThankYouComponents/EidSuccess.vue';
import CourierSuccess from '@/pagesComponents/ThankYouComponents/CourierSuccess.vue';
import PostSuccess from '@/pagesComponents/ThankYouComponents/PostSuccess.vue';
import PrintSuccess from '@/pagesComponents/ThankYouComponents/PrintSuccess.vue';
import ContactPlaceSuccess from '@/pagesComponents/ThankYouComponents/ContactPlaceSuccess.vue';
import enums from '@/mixins/enums';
import distributionChannels from '@/mixins/distributionChannels';
import GA from '@/mixins/GA';

export default {
  name: 'ThankYouSuccess',
  components: {
    Card,
    Container,
    EidSuccess,
    CourierSuccess,
    PostSuccess,
    PrintSuccess,
    ContactPlaceSuccess,
  },
  mixins: [enums, distributionChannels, GA],
  props: {
    model: { required: true, type: Object },
  },
  computed: {
    DeliveryTypeEnum() { return this.enums.DeliveryTypeEnum; },
  },
  created() {
    this.$router.maxStep = 23;
    this.model.step = 23;
    if (this.model.lastStep < 23) this.model.lastStep = 23;
  },
  mounted() {
    this.funnelCompleted();
  },
};
</script>
